import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles, {
  ContainerPrincipal,
  TitleTable,
} from './RendimentoMensalComercialStyles';
import { GroupDefinitions } from '../../../components/NavBar/Dialog/DialogAlterarSenhaStyles';
import RadioField from '../../../components/UI/Field/Radio/RadioField';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm';
import { ButtonUI, SelectorField } from '../../../components';
import SelectorModel from '../../../models/SelectorModel';
import {
  findRendimentoMensalComercial, findUsuariosComerciais, imprimirRendimentoMensalComercialExcel, imprimirRendimentoMensalComercialPdf,
} from '../../../services/core/analiseGerencial/analiseGerencial.service';
import DateField from '../../../components/UI/Field/Date/DateField';
import {
  downloadFileSispag, openPageFileBase64, toBrazilianDate,
} from '../../../helpers';
import CheckboxField from '../../../components/UI/Field/Checkbox/CheckboxField';
import Dica from '../../../components/UI/Dica/Dica';
import SearchButtonWithLabel from '../../../components/UI/Button/Search/Label/SearchButtonWithLabel';
import { ClearButton } from '../../../components/AtualizarMuralDashboard/atualizarMuralDashboard.styles';
import TabelaRendimentoMensalComercial from './TabelaRendimentoMensalComercial';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';

function RendimentoMensalComercialComponent() {
  const styles = useStyles();

  const [apenasAtivosDefinition, setApenasAtivosDefinition] = useState('0');
  const [comercialEspecifico, setComercialEspecifico] = useState(false);
  const [idUsuarioComercial, setIdUsuarioComercial] = useState('');
  const [usuariosComerciais, setUsuariosComerciais] = useState([]);
  const [dataReferencia, setDataReferencia] = useState(toBrazilianDate(new Date()));
  const [dataReferenciaNova, setDataReferenciaNova] = useState(toBrazilianDate(new Date()));
  const [selecionarDosDoisSistemas, setSelecionarDosDoisSistemas] = useState(true);
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(false);

  const onChangeApenasAtivosHandler = useCallback((event) => {
    const { value } = event.target;
    setApenasAtivosDefinition(value);
    setComercialEspecifico(value === '1');
    if (value !== '1') {
      setIdUsuarioComercial('');
    }
  }, [setComercialEspecifico, setApenasAtivosDefinition]);

  const onSubmitHandler = useCallback(() => {
    setLoading(true);
    setContent([]);
    setDataReferenciaNova(dataReferencia);

    findRendimentoMensalComercial(dataReferencia, idUsuarioComercial, apenasAtivosDefinition === '2', selecionarDosDoisSistemas)
      .then((response) => {
        setContent(response.data);
        if (response.data.length === 0) {
          toast.error('Nenhum resultado foi encontrado relacionado à sua pesquisa');
        } else {
          toast.success('Pesquisa realizada com sucesso!');
        }
      }).finally(() => {
        setLoading(false);
      });
  }, [dataReferencia, idUsuarioComercial, apenasAtivosDefinition, selecionarDosDoisSistemas]);

  const onLimparHandler = useCallback(() => {
    setApenasAtivosDefinition('0');
    setComercialEspecifico(false);
    setIdUsuarioComercial('');
    setDataReferencia(toBrazilianDate(new Date()));
    setDataReferenciaNova(toBrazilianDate(new Date()));
    setSelecionarDosDoisSistemas(true);
    setContent([]);
  }, []);

  const onClickExportarExcel = useCallback(() => {
    setLoading(true);
    imprimirRendimentoMensalComercialExcel(dataReferencia, idUsuarioComercial, apenasAtivosDefinition === '2', selecionarDosDoisSistemas).then((response) => {
      if (response.data.length > 0) {
        downloadFileSispag(response.headers.filename, response.data);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o Excel. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [apenasAtivosDefinition, dataReferencia, idUsuarioComercial, selecionarDosDoisSistemas]);

  const onClickExportarPDF = useCallback(() => {
    setLoading(true);
    imprimirRendimentoMensalComercialPdf(dataReferencia, idUsuarioComercial, apenasAtivosDefinition === '2', selecionarDosDoisSistemas).then((response) => {
      if (response.data.length > 0) {
        openPageFileBase64(response.data, response.headers['content-type']);
      }
    }).catch(() => {
      toast.error('Erro ao gerar o PDF. Tente novamente mais tarde.');
    }).finally(() => {
      setLoading(false);
    });
  }, [apenasAtivosDefinition, dataReferencia, idUsuarioComercial, selecionarDosDoisSistemas]);

  useEffect(() => {
    if (usuariosComerciais.length === 0) {
      findUsuariosComerciais().then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuariosComerciais(resposta);
      });
    }
  }, [usuariosComerciais.length]);

  return (
    <ContainerPrincipal>
      <LoadingUI show={loading} />

      <div style={{ border: '1px solid', padding: '10px', width: '60%' }}>
        <WrapperSubTitleForm title="Opções de consulta">
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ border: '1px solid', padding: '10px', width: '70%' }}>
              <GroupDefinitions
                aria-label="apenasAtivos"
                value={apenasAtivosDefinition}
                onChange={onChangeApenasAtivosHandler}
              >
                <div style={{ width: '100%' }}>
                  <RadioField
                    label="Todos os Comerciais"
                    value="0"
                    style={{ marginTop: '0px' }}
                  />
                </div>
                <div style={{ width: '100%', display: 'flex' }}>
                  <RadioField label="Comercial:" value="1" style={{ marginTop: '0px' }} />
                  <SelectorField
                    style={{ width: '300px' }}
                    isForm
                    hasEmptyLabel
                    disabled={comercialEspecifico !== true}
                    items={usuariosComerciais}
                    name="idUsuarioComercial"
                    value={idUsuarioComercial}
                    onChange={(e) => {
                      setIdUsuarioComercial(e.target.value);
                    }}
                  />
                </div>
                <div style={{ width: '100%' }}>
                  <RadioField label="Apenas os Ativos" value="2" style={{ marginTop: '0px' }} />
                </div>
              </GroupDefinitions>
            </div>

            <div style={{
              border: '1px solid', padding: '10px', width: '28%', alignContent: 'center',
            }}
            >
              <div style={{ margin: '5px' }}>
                <DateField
                  isForm
                  label="Data de Referência"
                  name="Data de Referência"
                  value={dataReferencia}
                  onChange={e => setDataReferencia(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div style={{ marginTop: '10px' }}>
            <div className={styles.checkboxContainer}>
              <div>
                <CheckboxField
                  label="Selecionar dados dos dois sistemas"
                  name="selecionarDosDoisSistemas"
                  checked={selecionarDosDoisSistemas}
                  onChange={e => setSelecionarDosDoisSistemas(e.target.checked)}
                />
              </div>
              <div>
                <Dica mensagemDica="Utilizar dados do sistema ABE e do sistema ABE Web para geração do relatório." />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
            <div>
              <ClearButton
                style={{ width: '150px' }}
                onClick={() => { onLimparHandler(); }}
                iconFontAwesome="fas fa-eraser"
                label="Limpar"
              />
              <SearchButtonWithLabel
                style={{ width: '150px', marginLeft: '10px' }}
                label="Pesquisar"
                type="button"
                onClick={() => { onSubmitHandler(); }}
              />
            </div>
          </div>
        </WrapperSubTitleForm>
      </div>
      <div style={{
        border: '1px solid', padding: '10px', width: '100%', marginTop: '10px',
      }}
      >
        <WrapperSubTitleForm title="Exportar">
          <div style={{ marginTop: '10px' }}>
            <ButtonUI
              style={{ width: '100px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarExcel(); }}
            >
              Excel
            </ButtonUI>
            <ButtonUI
              style={{ width: '100px', marginLeft: '10px' }}
              color="white"
              disabled={content.length === 0}
              onClick={() => { onClickExportarPDF(); }}
            >
              PDF
            </ButtonUI>
          </div>
          <TitleTable>
            Rendimento Mensal dos Comerciais
          </TitleTable>
          <TabelaRendimentoMensalComercial
            content={content}
            dataBase={dataReferenciaNova}
          />
        </WrapperSubTitleForm>
      </div>
    </ContainerPrincipal>
  );
}

export const RendimentoMensalComercial = withRouter(RendimentoMensalComercialComponent);
